import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=54ea89c9&scoped=true"
import script from "./checkout.js?vue&type=script&lang=js&external"
export * from "./checkout.js?vue&type=script&lang=js&external"
import style0 from "./checkout.scss?vue&type=style&index=0&id=54ea89c9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ea89c9",
  null
  
)

export default component.exports